import css from 'styled-jsx/css';
import { colors, screen } from './variables';

const articleThumbnailCSS = css`
  article {
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
  }

  article.lg {
    flex-direction: column;
    margin-bottom: 0;
  }

  @media screen and (min-width: ${screen.mdMin}) {
    article {
      margin-bottom: 24px;
    }
  }

  .title {
    font-size: 13px;
    line-height: 1.14;
    font-weight: bold;
    display: block;
    margin-top: 10px;
    margin-bottom: 8px;
    padding: 0;
    color: ${colors.BLACK};
    text-decoration: none;
  }

  .lg .title {
    font-size: 15px;
    line-height: 1.14;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    max-height: 60px;
    height: fit-content;
    margin-top: 20px;
    letter-spacing: normal;
    color: ${colors.BLACK};
  }

  @media screen and (min-width: ${screen.xsMax}) {
    .title {
      font-size: 17px;
      line-height: 1.11;
    }

    .lg .title {
      font-size: 22px;
      line-height: 1.09;
    }
  }

  .data {
    padding: 8px 16px 10px 10px;
    height: 100px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .lg .data {
    padding: 10px 10px 10px 20px;
  }

  @media screen and (min-width: ${screen.xsMax}) {
    .data {
      padding: 37px 30px 11px 31px;
      height: auto;
    }

    .lg .data {
      padding: 35px 39px 10px 38px;
      height: 150px;
    }
  }

  @media screen and (min-width: ${screen.smMax}) {
    .data {
      padding: 18px 26px 8px 26px;
    }

    .lg .data {
      padding: 42px 34px 8px 32px;
      height: 181px;
    }
  }

  .thumb {
    height: 100px;
    width: 160px;
    float: left;
    cursor: pointer;
    object-fit: cover;
  }

  .lg .thumb {
    height: 208px;
    width: 100%;
    object-fit: cover;
  }

  @media screen and (min-width: ${screen.xsMax}) and (max-width: ${screen.smMax}) {
    .thumb {
      height: 180px;
      width: 340px;
    }

    .lg .thumb {
      height: 390px;
    }
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .thumb {
      max-width: 292px;
      min-width: 220px;
      width: 50%;
      height: 157px;
    }

    .lg .thumb {
      width: 100%;
      max-width: 560px;
      height: 338px;
    }
  }

  .category {
    background-color: white;
    color: ${colors.G4};
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.2px;
    width: fit-content;
  }

  .featured {
    background-color: ${colors.ALR1};
    color: white;
    padding: 2px 8px 2px 8px;
    font-size: 12px;
  }

  .byline {
    visibility: hidden;
    width: fit-content;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    color: ${colors.BLACK};
  }

  @media screen and (min-width: ${screen.xsMax}) {
    .byline {
      visibility: visible;
    }
  }
`;

export default articleThumbnailCSS;
